import type { ReactNode } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  ${({ theme }) => theme.device.tablet} {
    display: none;
  }
`;

export interface DesktopBlockProps {
  children: ReactNode;
  className?: string;
}

export function DesktopBlock({ children, className }: DesktopBlockProps) {
  return <Wrapper className={className}>{children}</Wrapper>;
}
